export default "__VITE_ASSET__CCteimD___"